import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SimpleHeaderTextItemBlockConfig } from '@front-platform/content-builder';
import { simpleHeaderTextItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { Router } from '@angular/router';
export interface SimpleHeaderTextItemBlockRuntimeConfig {}

export type SimpleHeaderTextItemBlockConfigInput = Partial<
  Omit<SimpleHeaderTextItemBlockConfig, keyof SimpleHeaderTextItemBlockRuntimeConfig> &
    SimpleHeaderTextItemBlockRuntimeConfig
>;
export type SimpleHeaderTextItemBlockResolvedConfig = Omit<
  SimpleHeaderTextItemBlockConfig,
  keyof SimpleHeaderTextItemBlockRuntimeConfig
> &
  Partial<SimpleHeaderTextItemBlockRuntimeConfig>;
export interface SimpleHeaderTextItemBlockContract extends ConfigComponentContract<
  SimpleHeaderTextItemBlockConfigInput,
  SimpleHeaderTextItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-simple-header-text-item-block',
  templateUrl: './simple-header-text-item-block.component.html',
  styles: [],
  standalone: false,
})
export class SimpleHeaderTextItemBlockComponent implements SimpleHeaderTextItemBlockContract {
  readonly config = input<SimpleHeaderTextItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SimpleHeaderTextItemBlockConfig,
    SimpleHeaderTextItemBlockRuntimeConfig
  >(simpleHeaderTextItemBlockResolveConfig, () => ({ config: this.config() }));
  get text(): string | undefined {
    return this.resolvedConfig()['text'] as unknown as string | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  get linkTarget(): string {
    return this.resolvedConfig()['link_target'] as unknown as string;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get activeTextColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['active_text_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }

  constructor(private router: Router) {}

  isCurrentRoute(linkUrl?: string): boolean {
    if (!linkUrl) return false;

    const currentUrl = this.stripLanguageCode(this.router.url);
    const targetUrl = this.stripLanguageCode(linkUrl);
    return currentUrl === targetUrl;
  }

  /**
   * Supprime le code de langue à deux lettres au début de l'URL.
   */
  private stripLanguageCode(url: string): string {
    return url.replace(/^\/[a-z]{2}(\/|$)/i, '/');
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SimpleHeaderTextItemBlockComponent, {
  'keyAliases': {},
});
